import React from 'react';
/** @jsx jsx */
import {jsx, css} from '@emotion/core';
import styled from '@emotion/styled';
import api from '../api';
import CardFragment, { stripe } from '../ui/card';
import SettingHeader from '../ui/setting-header';
import Container from '../ui/container';
import { OutlinePillNavButton } from '../ui/button';
import theme from '../ui/theme';
import App from '../app';

export default () => {
  const app = React.useContext(App);
  const [card, setCard] = React.useState('xxxx');

  React.useEffect(() => {
    api()('/sub')
      .then(rs => rs.data.subscription.card)
      .then(card => setCard(card))
      .catch(e => {
        console.error('Failed to load subscription info:', e);
        if (e.response && e.response.status === 404) {
          app.flash('サブスクリプション情報が見つかりません。サポートにお問い合わせください。');
        } else {
          app.error();
        }
      });
  }, []);

  const submit = async ({payload, error}) => {
    if (error) {
      app.error();
      return
    }

    const card = payload;

    try {
      const response = await api().patch('/sub/card', {card});
      
      if (response.data.setup_intent) {
        // 3Dセキュア認証が必要
        const result = await stripe.then(stripe => stripe.confirmCardSetup(response.data.setup_intent, {
          payment_method: card
        }));
        
        if (result.error) {
          throw result.error;
        }
        
        // 3Dセキュア確認後、Setup IntentのIDを送信してカード変更完了を通知
        await api().post('/sub/card/confirm', {
          setup_intent_id: result.setupIntent.id
        });
      }
      
      // カード情報を再取得
      const updatedCard = await api()('/sub').then(rs => rs.data.subscription.card);
      setCard(updatedCard);
      app.flash('カードを変更しました');
    } catch (e) {
      console.error('Card update error:', e);
      
      if (e.response) {
        const status = e.response.status;
        const message = e.response.data && (e.response.data.message || e.response.data.error);
        
        if (status === 404) {
          app.flash('サブスクリプションが見つかりません。サポートにお問い合わせください。');
        } else if (status === 403) {
          app.flash('この支払い情報は現在ご利用いただけません。');
        } else if (message) {
          app.flash(message);
        } else {
          app.error();
        }
      } else {
        app.error();
      }
    }
  };

  return <Card card={card} onSubmit={submit}/>;
};

const Card = ({card, onSubmit}) => {
  return (
    <Container css={{paddingTop: 50}}>
      <SettingHeader title="お支払い情報変更"/>
      <Current card={card}/>
      <Card.Spacing>
        <CardFragment submitLabel="変更する" onResult={onSubmit}/>
      </Card.Spacing>
      <div css={{marginTop: 40}}>
        <OutlinePillNavButton color={theme.colors.accent} to="/settings" children="設定へ戻る" caret="left"/>
      </div>
    </Container>
  );
}

Card.Spacing = styled.div`
  margin-top: 40px;
`;

const Current = ({card}) => (
  <Current.Box>
    <Current.Label>現在のカード</Current.Label>
    xxxx-xxxx-xxxx-{card}
  </Current.Box>
);

Current.Box = styled.div`
  border: 1px solid #999;
  padding: 10px;
`;

Current.Label = styled.span`
  font-weight: bold;
  padding-right: 10px;
`;